import swal from "sweetalert";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import { copiarCuadroTurnos } from "../../services/nomina-cuadro-turnos";
import SelectController from "../../../../core/ui/components/SelectController";
import { selectEmpleadosConReglasOSecuencias } from "../../../../modules/Personas/services/empleados-service";
import { useForm } from "react-hook-form";

const FormCopiarCuadroTurnos = ({
    onCoppied,
    startDate,
    endDate,
    modalState,
    cuadroTurnos = [],
}) => {
    const [empleados, setEmpleados] = useState([]);

    const copiarTurnos = async (data) => {
        const resp = await copiarCuadroTurnos(data);

        if (!resp.status) {
            return toast.error("Ha ocurrido un error al copiar los turnos");
        }

        toast.success(resp.message);
        onCoppied();
    };

    const form = useForm();

    const onSubmit = (data) => {
        // Encontrar empleados que ya tienen turnos asignados, para mostrar alerta de
        // que se van a reescribir
        const encontrados = data.empleados.reduce((prev, empleado) => {
            const encontrado = cuadroTurnos.find((empleadoCT) => {
                return empleadoCT.id_persona == empleado.value;
            });

            if (encontrado == null) return prev;
            return [...prev, encontrado];
        }, []);

        const dataCuadroTurnos = {
            fechaFin: endDate,
            fechaInicio: startDate,
            persona_id: modalState.data.personaId,
            empleados: data.empleados.map((emp) => emp.value),
        };

        if (encontrados.length == 0) {
            return copiarTurnos(dataCuadroTurnos);
        }

        swal(
            "Algunos de estos usuarios ya tienen turnos creados en este rango de fecha ¿Está seguro que desea reescribirlos?",
            {
                buttons: {
                    cancel: "Cancelar",
                    confirm: "Confirmar",
                },
            }
        ).then((value) => {
            if (value) copiarTurnos(dataCuadroTurnos);
        });
    };

    useEffect(async () => {
        const resp = await selectEmpleadosConReglasOSecuencias();
        if (!resp.status) return toast.error(resp.message);

        setEmpleados(
            resp.data.map((empleado) => {
                return {
                    label: empleado.info_persona,
                    value: empleado.id,
                };
            })
        );
    }, []);

    return (
        <FormModal
            size="md"
            form={form}
            onSubmit={onSubmit}
            id="formCopiarTurnos"
            isOpen={modalState.show}
            closeModal={() => modalState.close()}
            headerTitle="Copiar cuadro de turnos"
        >
            <Row>
                <Col md={12}>
                    <SelectController
                        isMulti={true}
                        errors={form.formState.errors}
                        name="empleados"
                        label="Empleados"
                        control={form.control}
                        options={empleados}
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormCopiarCuadroTurnos.propTypes = {
    onCoppied: PropTypes.func,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    modalState: PropTypes.object,
    cuadroTurnos: PropTypes.array,
};

export default FormCopiarCuadroTurnos;
